import {parametros_rota} from "./ParametrosRota";

export const categoria_selecionada = {
  mixins: [parametros_rota],
  computed: {
    categoria_selecionada: {
      get() {
        return this.$store.getters["comprasPorDepartamentos/categoria_selecionada"];
      },
      set(categoria) {
        return this.$store.dispatch("comprasPorDepartamentos/categoria_selecionada", categoria);
      }
    }
  },
  watch: {
    PARAMETROS() {
      this.categoria_selecionada = null;
    }
  },
  destroyed() {
    this.categoria_selecionada = null;
  }
}
